import { makeStyles, TextField } from "@material-ui/core";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { handleKeywordKeyPress } from "../../common/handleKeyWordPress";
import { verifyEmailUrl } from "../../common/infrastructure/endpoints";
import { post } from "../../common/infrastructure/requests";

interface IEnterEmail {
  setProposedEmail: (email: string) => void;
  email: string;
  currentEmail: string | null;
}

const useStyles = makeStyles({
  button: {
    marginBottom: "1rem",
  },
});

export const EnterEmail: React.FC<IEnterEmail> = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [errorMessage, setErrorMessage] = React.useState<string>("");

  const handleGoNext = async () => {
    try {
      if (!props.email || !props.email.includes("@")) {
        setErrorMessage(t("Please enter a valid email address"));
        return;
      }

      const resp = await post<any, { email: string }>(verifyEmailUrl(), {
        email: props.email,
      });

      if (resp) {
        setErrorMessage("");
        //@ts-ignore
        props.nextStep();
        return;
      }
    } catch (e) {
      setErrorMessage(t("System error, please try again later."));
    }
  };

  return (
    <Grid container direction="column" wrap="nowrap">
      <DialogContent>
        <DialogTitle>{t("Email address")}</DialogTitle>
        <TextField
          fullWidth
          variant="outlined"
          placeholder={t("Enter email address")}
          required
          type="email"
          defaultValue={props.currentEmail || ""}
          onChange={(e) => props.setProposedEmail(e.target.value)}
          helperText={errorMessage}
          classes={{ root: classes.button }}
          onKeyDown={(e) => handleKeywordKeyPress(e, handleGoNext)}
        />
        <DialogContentText color="primary">
          {t(
            "Enter the email address you wish to register. We will send you a verification code to confirm the email address."
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          disabled={!props.email || !props.email.includes("@") || props.email === props.currentEmail}
          onClick={() => handleGoNext()}
        >
          {t("Send verification code")}
        </Button>
      </DialogActions>
    </Grid>
  );
};
